module.exports = __webpack_public_path__ + "static/media/mail.c4fc4b0b.svg";